// src/components/Home/Section3.jsx
import React from "react";
import { motion } from "framer-motion";

const listaIzq = [
  "Dispositivos herramentales y facilidades",
  "Elementos de seguridad y accesorios",
  "Cañerías y ductos de proceso y servicios auxiliares",
  "Equipos e intercambiadores de calor",
  "Tanques de almacenamiento",
];

const listaDer = [
  "Soldadura especiales en aceros inoxidables y aluminio",
  "Inspección de soldadura y ensayos no destructivos",
  "Asesoramiento técnico en soldadura",
  "Verificación estructural por elementos finitos (FEA)",
];

const pasos = [
  {
    n: 1,
    titulo1: "VISTA",
    titulo2: "RELEVAMIENTO",
    desc: "Escuchamos, evaluamos y analizamos tu requerimiento en el lugar.",
  },
  {
    n: 2,
    titulo1: "INGENIERÍA",
    titulo2: "PROPUESTA",
    desc: "Diseñamos y presentamos soluciones claras, integrales y a medida.",
  },
  {
    n: 3,
    titulo1: "DESARROLLO",
    titulo2: "FABRICACIÓN",
    desc: "Manos a la obra con experiencia, calidad y total confiabilidad.",
  },
  {
    n: 4,
    titulo1: "SERVICIO",
    titulo2: "POSTVENTA",
    desc: "Brindamos soporte y seguimiento post-entrega para asegurar resultados.",
  },
];

const fadeUp = {
  hidden: { opacity: 0, y: 24 },
  show: { opacity: 1, y: 0, transition: { duration: 0.5 } },
};

const Section3 = () => {
  return (
    <section
      id="que-hacemos"
      className="min-h-screen w-full flex items-center justify-center py-16 sm:py-24"
    >
      <div className="w-full max-w-[1200px] mx-auto px-6">
        {/* Header */}
        <motion.div
          variants={fadeUp}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.3 }}
          className="mb-10 sm:mb-14"
        >
          <h3 className="text-[32px] sm:text-[48px] text-white font-inversionzUnboxed text-center">
            QUÉ HACEMOS
          </h3>
          <div className="mt-4 flex items-center gap-3">
            <span className="h-[1px] rounded-sm flex-1 bg-white" />
            <span className="h-[4px] w-16 bg-[#21C0A8] rounded-sm" />
            <span className="h-[1px] rounded-sm flex-1 bg-white" />
          </div>
        </motion.div>

        {/* Pastilla 1 */}
        <motion.div
          variants={fadeUp}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.3 }}
          className="mx-auto mb-8 sm:mb-12 max-w-[820px]"
        >
          <div className="rounded-full border border-white/50 px-6 sm:px-10 py-4 sm:py-5 text-center">
            <div className="text-white font-bai font-semibold text-base sm:text-lg">
              Qué soluciones brindamos
            </div>
            <div className="text-gray-200 font-bai text-md sm:text-base">
              Ingeniería, desarrollo y fabricación de:
            </div>
          </div>
        </motion.div>

        {/* Listas 2 columnas */}
        <motion.div
          variants={fadeUp}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.3 }}
          className="grid grid-cols-1 sm:grid-cols-2 gap-8 sm:gap-12 justify-center text-gray-200/90 font-bai text-md sm:text-base leading-relaxed mb-10 sm:mb-14 max-w-4xl mx-auto"
        >
          <ul className="list-disc pl-5 space-y-2">
            {listaIzq.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
          <ul className="list-disc pl-5 space-y-2">
            {listaDer.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        </motion.div>

        {/* Pastilla 2 */}
        <motion.div
          variants={fadeUp}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.3 }}
          className="mx-auto mb-6 sm:mb-10 max-w-[820px]"
        >
          <div className="rounded-full border border-white/50 px-6 sm:px-10 py-4 sm:py-5 text-center">
            <div className="text-white font-bai font-semibold text-base sm:text-lg">
              Cómo lo hacemos
            </div>
            <div className="text-gray-200 font-bai text-md sm:text-base">
              Nuestro proceso en 4 pasos:
            </div>
          </div>
        </motion.div>

        {/* Pasos */}
        <motion.div
          variants={fadeUp}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.2 }}
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 w-[70%] mx-auto items-start"
        >
          {pasos.map((p, i) => (
            <motion.div
              key={p.n}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.45, delay: 0.08 * i }}
              className="flex w-full flex-col justify-start sm:text-left"
            >
              <div className="flex w-full items-start justify-start mb-2">
                <div className="text-[#21C0A8] font-bai italic text-[44px] leading-none mr-4">
                  {p.n}
                </div>
                <div className="text-white font-bai whitespace-pre-line leading-tight">
                  <span className="block text-[12px] sm:text-sm font-normal tracking-wide">
                    {p.titulo1}
                  </span>
                  <span className="block text-md sm:text-base font-semibold">
                    {p.titulo2}
                  </span>
                </div>
              </div>
              <p className="text-gray-300 text-md leading-relaxed">{p.desc}</p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Section3;